import React, { FC } from 'react'
import CircleCheckboxIcon from '../CircleCheckboxIcon'
import './styles.scss'

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const CircleCheckbox: FC<any> = ({
  name,
  state = false,
  onChangeState,
  disabled = false,
  type = 'normal',
  titleClass = '',
}) => {
  const onChange = (): void => {
    if (!disabled) {
      onChangeState()
    }
  }
  return (
    <div
      className="circle-checkbox-container"
      onClick={onChange}
      role="button"
      tabIndex={0}
      onKeyDown={(): void => {}}
    >
      <CircleCheckboxIcon state={state} disabled={disabled} type={type} />
      <p className={`${disabled ? 'disabled' : ''} ${titleClass}`}>{name}</p>
    </div>
  )
}

export default CircleCheckbox
